import React, { Component } from 'react';
import { func, object } from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { closeAlertDialog, openErrorDialog } from '../../../../actions/dialog/dialogActions';
import { chooseAccount, getAccounts } from '../../../../actions/familyAccess/familyAccessActions';
import { fetchAuthenticatedPreferences } from '../../../../actions/preferences/preferencesAction';
import { setHeaderTitle } from '../../../../actions/header/headerActions';
import { setMetadata } from '../../../../actions/metadata/metadataActions';

// Main Layout Components
import ContentPanel from '../../../ContentPanel';
import FamilyMemberItem from '../FamilyMemberItem';

// Page styles
import s from './LandingPage.css';


export class LandingPage extends Component {
  static propTypes = {
    closeAlertDialog: func,
    familyAccess: object,
    fetchAuthenticatedPreferences: func,
    getAccounts: func,
    loading: object,
    openErrorDialog: func,
    setHeaderTitle: func,
    setMetadata: func,
  };

  componentWillMount() {
    this.props.setMetadata({
      activeMenuItemKey: 'family',
      pageTitle: 'Family',
      pageDescription: 'Switch between Family Access accounts',
    });

    this.props.setHeaderTitle('Family');
  };

  componentDidMount() {
    this.props.getAccounts();
  }

  getAccounts = () => this.props.getAccounts();

  // Always fetchAuthenticatedPreferences after switching accounts
  handleUpdate = () => {
    this.props.fetchAuthenticatedPreferences();
    this.getAccounts();
  };

  render = () =>
    <ContentPanel className={s.contentPanel}>
      {this.props.familyAccess.primary &&
      <FamilyMemberItem
        active={this.props.familyAccess.primary.patientId === this.props.familyAccess.active.patientId}
        chooseAccount={this.props.chooseAccount}
        closeAlertDialog={this.props.closeAlertDialog}
        member={this.props.familyAccess.primary}
        openErrorDialog={this.props.openErrorDialog}
        onSwitch={this.handleUpdate}
        primary
      />
      }
      {this.props.familyAccess.accounts && this.props.familyAccess.accounts.length > 0 &&
      this.props.familyAccess.accounts.map(member => (
        <FamilyMemberItem
          chooseAccount={this.props.chooseAccount}
          closeAlertDialog={this.props.closeAlertDialog}
          key={member.patientId}
          active={member.patientId === this.props.familyAccess.active.patientId}
          member={member}
          openErrorDialog={this.props.openErrorDialog}
          onSwitch={this.handleUpdate}
        />
      ))
      }
    </ContentPanel>
}

const mapStateToProps = (state) => ({
  loading: state.loadingState,
  familyAccess: state.familyAccess,
});

const mapDispatchToProps = dispatch => ({
  chooseAccount: (accountId, successCb, errorCb) => dispatch(chooseAccount(accountId, successCb, errorCb)),
  closeAlertDialog: () => dispatch(closeAlertDialog()),
  openErrorDialog: dialog => dispatch(openErrorDialog(dialog)),
  fetchAuthenticatedPreferences: () => dispatch(fetchAuthenticatedPreferences()),
  getAccounts: () => dispatch(getAccounts()),
  setHeaderTitle: title => dispatch(setHeaderTitle(title)),
  setMetadata: metadata => dispatch(setMetadata(metadata)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/components/Pages/Family/LandingPage/LandingPage.js